import { render, staticRenderFns } from "./EWTrxHistoryList.vue?vue&type=template&id=36d5ad4a&"
import script from "./EWTrxHistoryList.vue?vue&type=script&lang=js&"
export * from "./EWTrxHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports